import { Link } from 'react-router-dom';

import { ReactComponent as PaperclipIcon } from 'assets/icons/paperclip.svg';
import { LegalTermWrapper } from 'components/index';

import style from 'src/components/layout/LegalTermWrapper/LegalTermWrapper.module.scss';
import { CONTACT_EMAIL } from 'src/constants/misc';

const Statute = () => {
  return (
    <LegalTermWrapper
      pageTitle={'Terms and Conditions'}
      documentTitle={'OGÓLNE WARUNKI ŚWIADCZENIA USŁUG APLIKACJI AVALIO'}
    >
      <p className={style.text}>
        Niniejsze OWU określa zasady, na jakich Usługodawca, tj. CBM 16 spółka z ograniczoną odpowiedzialnością̨ z siedzibą w
        Jasionce, wpisana do rejestru przedsiębiorców prowadzonego przez Sąd Rejonowy w Rzeszowie, XIII Wydział Gospodarczy pod
        numerem KRS: 0000809744, NIP 5170402504, REGON 384670823, o kapitale zakładowym w wysokości 10.000 złotych, świadczy na
        rzecz swoich klientów (zwanych dalej „Usługobiorcami”) usługi związane z udostępnieniem i zapewnieniem możliwości
        korzystania z Aplikacji Avalio, uzupełniając jednocześnie treść zawieranych Umów i stanowiąc ich integralną część.
        <br />
        <br />
        OWU stanowi również regulamin świadczenia usług drogą elektroniczną za pośrednictwem Aplikacji. Usługobiorca zobowiązany
        jest do zapoznania każdego Użytkownika z treścią OWU w zakresie w jakim jest to konieczne aby miał on wiedzę o swoich
        prawach i obowiązkach związanych z korzystaniem z Aplikacji.{' '}
      </p>

      <h3 className={style.section_header}>DEFINICJE</h3>
      <table
        className={style.definition_table}
        border={0}
      >
        <tbody>
          <tr>
            <td className={style.term}>Aplikacja</td>
            <td className={style.description}>
              aplikacja Avalio dostępna w modelu SaaS (Software as a Service), dostarczana przez Usługodawcę na rzecz Usługobiorcy
              na zasadach określonych w OWU oraz Umowie
            </td>
          </tr>
          <tr>
            <td className={style.term}>Funkcjonalność</td>
            <td className={style.description}>moduł Aplikacji wskazany w Umowie, udostępniany Usługobiorcy przez Usługodawcę</td>
          </tr>
          <tr>
            <td className={style.term}>Konto</td>
            <td className={style.description}>
              wydzielona indywidualnie Usługobiorcy część Aplikacji, w ramach której Usługobiorca (w tym przypisani do niego
              Użytkownicy) mogą korzystać z poszczególnych Funkcjonalności udostępnianych przez Usługodawcę zgodnie z Umową
            </td>
          </tr>
          <tr>
            <td className={style.term}>Lokalizacja</td>
            <td className={style.description}>
              wskazane w Umowie miejsce prowadzenia działalności przez Usługobiorcę w ramach którego Usługobiorca jest uprawniony
              do korzystania z Aplikacji
            </td>
          </tr>
          <tr>
            <td className={style.term}>Okres</td>
            <td className={style.description}>czas na jaki zawarta zostaje Umowa, każdorazowo wskazany w Umowie</td>
          </tr>
          <tr>
            <td className={style.term}>Opłata abonamentowa</td>
            <td className={style.description}>
              opłata należna Usługodawcy od Usługobiorcy z tytułu świadczenia Usług; wysokość oraz częstotliwość dokonywania Opłat
              abonamentowych określona jest w Umowie
            </td>
          </tr>
          <tr>
            <td className={style.term}>OWU</td>
            <td className={style.description}>niniejsze Ogólne Warunki Umowy</td>
          </tr>
          <tr>
            <td className={style.term}>Umowa</td>
            <td className={style.description}>
              umowa zawierana drogą elektroniczną (w formie dokumentowej) pomiędzy Usługodawcą a Usługobiorcą na podstawie OWU;
              Umowa reguluje m.in. biznesowe aspekty współpracy związanej z korzystaniem z Aplikacji przez Usługobiorcę
            </td>
          </tr>
          <tr>
            <td className={style.term}>Usługi</td>
            <td className={style.description}>usługi świadczone przez Usługodawcę za pośrednictwem Aplikacji</td>
          </tr>
          <tr>
            <td className={style.term}>Użytkownik</td>
            <td className={style.description}>
              uczłonek personelu Usługobiorcy uprawniony do korzystania z Aplikacji w ramach przypisanego do niego Konta
            </td>
          </tr>
          <tr>
            <td className={style.term}>Wdrożenie</td>
            <td className={style.description}>
              proces przygotowania Usługobiorcy oraz jego personelu do korzystania z Aplikacji w ramach danej Lokalizacji
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className={style.column_header}>
        <span>§ 1 </span>
        <span>PRZEDMIOT UMOWY</span>
      </h2>
      <ol className={style.list}>
        <li>
          Usługodawca oświadcza, że jest właścicielem i jedynym uprawnionym z tytułu autorskich praw majątkowych do Aplikacji.
        </li>
        <li>
          Podstawowym celem Aplikacji jest zintegrowane i profesjonalne wsparcie Usługobiorcy w zarządzaniu stroną kosztową
          podmiotów działających w branży ochrony zdrowia, począwszy od tworzenia zamówień, poprzez ich śledzenie, odbieranie i
          opłacanie wraz z automatyzacją procesów poprzez wykorzystanie sztucznej inteligencji. Mając na uwadze przeznaczenie
          Aplikacji jest ona udostępniana tylko Usługobiorcom, którzy posiadają status przedsiębiorcy w rozumieniu przepisów prawa
          i będą z niej korzystać w ramach prowadzonej działalności gospodarczej lub zawodowej. Brak posiadania takiego statusu
          uniemożliwia zawarcie Umowy, a w konsekwencji korzystanie z Aplikacji.
        </li>
        <li>
          Udostępnienie Aplikacji Usługobiorcy i korzystanie z niej przez Usługobiorcę, w tym Użytkowników, następuje drogą
          elektroniczną (on-line) za pośrednictwem sieci Internet w modelu Software as a Service, poprzez przekaz danych,
          przesyłanych i otrzymywanych za pomocą urządzeń do elektronicznego przetwarzania, włącznie z kompresją cyfrową i
          przechowywania danych, która jest w całości nadawana, odbierana lub transmitowana za pomocą sieci telekomunikacyjnej w
          rozumieniu ustawy Prawo komunikacji elektronicznej.
        </li>
        <li>
          W ramach zawartej Umowy Usługodawca zapewnia na rzecz Usługobiorcy świadczenie Usług za pośrednictwem Aplikacji, w
          zakresie Funkcjonalności określonych w Umowie.
        </li>
        <li>
          W ramach Umowy Usługobiorca z Usługodawcą określają co najmniej następujące dane dotyczące udostępnianej Aplikacji:
          <ol className={style.second_list_abc}>
            <li>liczbę Użytkowników oraz rodzaj Kont Użytkowników tworzonych dla Usługobiorcy;</li>
            <li>wysokość Opłaty abonamentowej oraz terminy jej opłacania przez Usługobiorcę;</li>
            <li>liczbę oraz położenie Lokalizacji;</li>
            <li>zakres Funkcjonalności udostępnianych w ramach Aplikacji na rzecz Usługobiorcy;</li>
            <li>czynności składające się na Wdrożenie oraz wynagrodzenie Usługodawcy za realizację Wdrożenia</li>
            <li>dodatkowe usługi świadczone przez Usługodawcę na rzecz Usługobiorcy, które zostały indywidualnie uzgodnione</li>
          </ol>
        </li>
        <li>
          W trakcie trwania Umowy Usługobiorca ma możliwość rozszerzenia Funkcjonalności Aplikacji. W tym celu Usługobiorca
          powinien zgłosić chęć dokonania zmian w zakresie Aplikacji Usługodawcy oraz dokonać potwierdzenia w zakresie
          wprowadzanych zmian, planowanego terminu ich Wdrożenia oraz uruchomienia oraz wysokość Opłaty abonamentowej po ich
          uwzględnieniu w formie mailowej, na adres e-mail <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 2 </span>
        <span>WDROŻENIE</span>
      </h2>
      <ol className={style.list}>
        <li>
          Termin Wdrożenia i uruchomienia Aplikacji zostaną wskazane w Umowie. Usługodawca zastrzega, że termin zakończenia
          Wdrożenia może ulec zmianie z przyczyn niezależnych od Usługodawcy, w tym w szczególności w przypadku wystąpienia siły
          wyższej lub specyficznej konstrukcji lub konfiguracji systemów informatycznych Usługobiorcy.
        </li>
        <li>
          W celu korzystania z Aplikacji oraz poszczególnych jej funkcjonalności konieczne jest dysponowanie przez Usługobiorcę
          sprzętem i systemem spełniającym następujące minimalne wymagania techniczne:
          <ol className={style.second_list_abc}>
            <li>
              urządzenie (w szczególności komputer) z dostępem do sieci Internet umożliwiające prawidłowe wyświetlenie interfejsu
              Aplikacji;
            </li>
            <li>aktywne konto poczty elektronicznej (e-mail);</li>
            <li>
              zainstalowana i zaktualizowana do najnowszej wersji przeglądarka internetowa Chrome, FireFox, Safari lub Opera;
            </li>
            <li>zainstalowana i włączona w przeglądarce obsługa języka JavaScript oraz włączona obsługa plików cookies.</li>
          </ol>
        </li>
        <li>
          Wdrożenie obejmuje każdorazowo następujące czynności:
          <ol className={style.second_list_abc}>
            <li>analizę przedwdrożeniową;</li>
            <li>zbudowanie zindywidualizowanej bazy produktów w Aplikacji;</li>
            <li>konfigurację i parametryzację Aplikacji zgodnie z potrzebami Usługobiorcy;</li>
            <li>szkolenie kadry działającej w ramach każdej z Lokalizacji;</li>
          </ol>
        </li>
        <li>
          Usługobiorca może w ramach zawartej Umowy powierzyć Usługodawcy wykonanie innych czynności poza czynnościami, o których
          mowa w ust. 3 powyżej, w tym powierzyć dostarczenie dodatkowych narzędzi lub usług, koniecznych do spełnienia warunków
          technicznych niezbędnych do uruchomienia i poprawnego działania Aplikacji, co musi zostać wprost wskazane w Umowie.
        </li>
        <li>
          Realizacja Wdrożenia i uruchomienie Aplikacji w terminie uzgodnionym w Umowie uzależnione jest od współpracy
          Usługobiorcy z Usługodawcą. Usługodawca nie ponosi odpowiedzialności za opóźnienia wywołane działaniami lub
          zaniechaniami po stronie Usługobiorcy.
        </li>
        <li>
          W przypadku wystąpienia przeszkód w wykonaniu Wdrożenia lub uruchomienia Aplikacji w uzgodnionym terminie, Usługodawca
          wraz z Usługobiorcą mogą uzgodnić inny termin ich realizacji, co nie wymaga sporządzenia aneksu do Umowy.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 3 </span>
        <span>LICENCJA ORAZ ZASADY KORZYSTANIA Z APLIKACJI PRZEZ USŁUGOBIORCĘ</span>
      </h2>
      <ol className={style.list}>
        <li>
          Usługodawca oświadcza, że przysługują mu wyłączne autorskie prawa majątkowe do Aplikacji oraz, że jest uprawniony do
          rozporządzania prawami autorskimi do Aplikacji w zakresie niezbędnym do zawarcia i wykonywania Umowy, w tym udzielenia
          licencji na korzystanie z Aplikacji w zakresie wskazanym w niniejszym paragrafie.
        </li>
        <li>
          Usługodawca udziela Usługobiorcy w ramach Opłaty abonamentowej, na czas trwania Umowy, niewyłącznej licencji na
          korzystanie z Aplikacji oraz wszystkich wprowadzonych w niej i udostępnionych Usługobiorcy aktualizacji, obejmującej
          następujące pola eksploatacji:
          <ol className={style.second_list_abc}>
            <li>prawo do korzystania z Aplikacji, zgodnie z jej charakterem i przeznaczeniem;</li>
            <li>prawo do wprowadzania danych do Aplikacji, zgodnie z jej charakterem i przeznaczeniem.</li>
          </ol>
        </li>
        <li>
          Aplikacja może być wykorzystywana przez Usługobiorcę, w tym Użytkowników związanych z Usługobiorcą wyłącznie w ramach
          prowadzonej przez niego działalności gospodarczej lub zawodowej, na zasadach określonych w OWU, Umowie oraz zgodnie z
          powszechnie obowiązującymi przepisami prawa.
        </li>
        <li>
          Usługobiorcy nie przysługuje prawo pobrania (trwałego zwielokrotniania) Aplikacji oraz jej zainstalowania na innym
          serwerze.
        </li>
        <li>
          Usługobiorcy nie przysługuje uprawnienie do korzystania z Aplikacji jako samodzielnego przedmiotu obrotu. Zabronione
          jest sprzedawanie, najmowanie, dzierżawienie, sublicencjonowanie, przenoszenie praw i obowiązków wynikających z zawartej
          Umowy oraz udostępnianie w jakiejkolwiek formie Aplikacji, jak i jej części osobom trzecim, w tym w Internecie oraz w
          postaci elektronicznej.
        </li>
        <li>
          Usługobiorca nie jest uprawniony do przekazywania danych dostępowych do Aplikacji podmiotom trzecim, w tym osobom innym
          niż Użytkownicy, dla których zostały utworzone Konta w ramach Aplikacji.
        </li>
        <li>
          Usługobiorca nie ma prawa do dekompilacji, dezasemblacji ani innych podobnych czynności (reverse engineering), jak i
          innych czynności związanych z nieautoryzowanym dostępem do zawartości baz danych lub dołączaniem innego oprogramowania
          wykorzystującego zawartość baz danych, o ile czynności takie nie są dozwolone przez bezwzględnie obowiązujące przepisy
          prawa.
        </li>
        <li>
          Usługodawcy zakazane jest umieszczanie w Aplikacji treści o charakterze bezprawnym, w szczególności treści naruszających
          dobra osobiste osób trzecich, nieprawdziwych, wulgarnych, sprzecznych z dobrymi obyczajami, naruszających zasady
          współżycia społecznego, wprowadzających w błąd lub mogących narazić Usługodawcę lub osoby trzecie na powstanie szkody.
          Usługodawca nie ponosi odpowiedzialności za umieszczanie w Aplikacji przez Usługobiorcę treści zakazanych.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 4 </span>
        <span>ODPOWIEDZIALNOŚĆ USŁUGODAWCY</span>
      </h2>
      <ol className={style.list}>
        <li>
          Usługodawca ponosi odpowiedzialność za nieprawidłowe wykonanie lub niewykonanie Umowy, wyłącznie w granicach szkody
          wyrządzonej wskutek winy umyślnej lub rażącego niedbalstwa.
        </li>
        <li>
          Usługodawca ponosi odpowiedzialność wyłącznie w granicach poniesionej przez Usługobiorcę szkody rzeczywistej, z
          wyłączeniem odpowiedzialności za utracone korzyści lub inne szkody nie będące rzeczywistą stratą Usługobiorcy.
        </li>
        <li>
          Odpowiedzialność Usługodawcy w każdym wypadku ograniczona jest do kwoty stanowiącej równowartość sześciokrotności Opłaty
          abonamentowej określonej w Umowie.
        </li>
        <li>
          Usługodawca nie ponosi odpowiedzialności za niewykonanie lub nieprawidłowe wykonanie Umowy, w przypadku wystąpienia
          szkody spowodowanej:
          <ol className={style.second_list_abc}>
            <li>nieprawidłowym użytkowaniem Aplikacji przez Usługobiorcę lub Użytkownika,</li>
            <li>udostępnieniem przez Usługobiorcę nieuprawnionym osobom trzecim danych dostępowych do Aplikacji,</li>
            <li>czynnikami zewnętrznymi lub leżącymi po stronie Usługobiorcy lub Użytkowników;</li>
            <li>
              ingerencją Usługobiorcy lub Użytkownika w infrastrukturę techniczną skonfigurowaną przez Usługodawcę w ramach
              wykonanego Wdrożenia lub dokonaniem niedozwolonej modyfikacji Aplikacji,
            </li>
            <li>brakiem nieprzerwanego dostępu do łącza internetowego Usługobiorcy,</li>
            <li>przyczynami leżącymi po stronie oprogramowania komputerowego Usługobiorcy,</li>
            <li>bezprawnymi działaniami osób trzecich, w tym w szczególności atakami hakerskimi.</li>
          </ol>
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 5 </span>
        <span>POSTĘPOWANIE REKLAMACYJNE</span>
      </h2>
      <ol className={style.list}>
        <li>Usługobiorca jest uprawniony do złożenia reklamacji dotyczącej sposobu i jakości świadczonych Usług.</li>
        <li>
          Reklamacja może zostać złożona przez Usługobiorcę w dowolnej formie, jednakże w celu usprawnienia postępowania
          reklamacyjnego zaleca się jej złożenie w formie elektronicznej na adres e-mail Usługodawcy:{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> lub pisemnej na adres siedziby Usługodawcy.
        </li>
        <li>Usługobiorca powinien zawrzeć w reklamacji opis problemu, w związku, z którego zaistnieniem składa reklamację.</li>
        <li>
          Usługodawca zobowiązany jest rozpatrzyć zgłoszoną przez Usługobiorcę reklamację bez zbędnej zwłoki, jednakże nie później
          niż w terminie 14 dni i poinformować Usługobiorcę o sposobie jej rozpatrzenia, za pośrednictwem poczty elektronicznej
          lub w formie pisemnej, w zależności od formy zgłoszenia reklamacji, na adres wskazany przez Usługobiorcę w reklamacji.
        </li>
        <li>
          W przypadku braków w reklamacji uniemożliwiających lub znacznie utrudniających jej rozpatrzenie, Usługodawca wezwie
          Usługobiorcę do jej uzupełnienia. W przypadku uzupełnienia braków reklamacji termin 14 dni roboczych na jej rozpatrzenie
          liczony jest od doręczenia nam prawidłowo uzupełnionej reklamacji.
        </li>
        <li>
          W przypadku braku rozpatrzenia reklamacji w terminach określonych w ust. 4 i 5 powyżej przyjmuje się, że Usługodawca
          uznał reklamację za zasadną.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 6 </span>
        <span>CZAS TRWANIA UMOWY I JEJ ROZWIĄZANIE</span>
      </h2>
      <ol className={style.list}>
        <li>Umowa zostaje zawarta na czas w niej wskazany.</li>
        <li>Usługobiorca zobowiązuje się do niewypowiadania Umowy w pierwszym okresie jej obowiązywania, określony w Umowie.</li>
        <li>
          Umowa ulega automatycznemu przedłużeniu o kolejny Okres równy poprzedniemu Okresowi określonemu w Umowie, chyba że
          którakolwiek ze stron (Usługodawca lub Usługobiorca) złoży drugiej stronie oświadczenie o zamiarze nieprzedłużania
          Umowy, nie później niż na 14 dni przed upływem dotychczasowego okresu.
        </li>
        <li>
          Oświadczenie, o którym mowa w ust. 3 powyżej może zostać złożone w formie dokumentowej (w tym elektronicznej) lub
          pisemnej. Datą złożenia oświadczania jest moment jego doręczenia stronie której jest składane.
        </li>
        <li>
          W przypadku przedłużenia Umowy zgodnie z ust. 3 powyżej, każda ze Stron jest uprawniona do rozwiązania Umowy za
          wypowiedzeniem skutecznym na koniec okresu objętego kolejną Opłatą abonamentową (następną po ostatniej Opłacie
          abonamentowej należnej Usługodawcy od Usługobiorcy).
        </li>
        <li>
          W przypadku opóźnienia przez Usługobiorcę z płatnością Opłaty abonamentowej przez okres przekraczający 14 dni
          Usługodawcy, niezależnie od uprawnienia do rozwiązania Umowy ze skutkiem natychmiastowym (bez okresu wypowiedzenia),
          przysługuje prawo do wstrzymania świadczenia na rzecz Usługobiorcy Usług będących przedmiotem Umowy, co może wiązać się
          z brakiem możliwości korzystania przez Usługobiorcę z funkcjonalności Aplikacji.
        </li>
        <li>
          W sytuacji, o której mowa w ust. 6 powyżej, Usługodawca zobowiązany jest przywrócić dostęp do usług będących przedmiotem
          Umowy, w tym do funkcjonalności Aplikacji najpóźniej kolejnego dnia roboczego następującego po dniu dokonania przez
          Usługobiorcę płatności zaległej Opłaty abonamentowej. Za moment zapłaty uważa się dzień uznania rachunku bankowego
          Usługodawcy.
        </li>
        <li>
          W przypadku zalegania przez Usługobiorcę z płatnością Opłaty abonamentowej, Usługodawca jest uprawniony do wprowadzenia
          do Aplikacji począwszy od dnia następującego po dniu płatności, komunikatu informującego Usługobiorcę o występującej
          zaległości w płatności Opłaty abonamentowej, co może wpłynąć na komfort użytkowania Aplikacji przez Usługobiorcę oraz
          Użytkowników.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 7 </span>
        <span>KLAUZULA POUFNOŚCI</span>
      </h2>
      <ol className={style.list}>
        <li>
          Dla celów Umowy, jako „Informacje Poufne” traktowane będą wszelkie informacje wzajemnie sobie przekazane przez Strony
          (zarówno przed zawarciem Umowy, m.in. w trakcie negocjacji, jak i po jej zawarciu) dotyczące ich działalności handlowej,
          operacyjnej, spraw finansowych, ekonomicznych, technologicznych, organizacyjnych oraz inne informacje dotyczące Stron,
          podmiotów z nimi powiązanych, ich klientów, doradców oraz wszystkich innych osób związanych odpowiednimi umowami ze
          Stronami przekazane przez Strony w formie pisemnej, elektronicznej, jak i ustnej, w tym w szczególności informacje
          uzyskane od Stron oraz ich pracowników i współpracowników, niezależnie od tego, czy taka informacja wyraźnie została
          oznaczona jako Informacja Poufna.
        </li>
        <li>
          Zobowiązanie nie ma zastosowania do informacji, które:
          <ol className={style.second_list_abc}>
            <li>były powszechnie dostępne w czasie ich ujawnienia;</li>
            <li>były w posiadaniu Stron przed ich udostępnieniem przez Strony, ich udziałowców/akcjonariuszy lub inne osoby;</li>
            <li>zostały uzyskane od strony trzeciej, uprawnionej do jej udzielenia;</li>
            <li>
              zostały ujawnione przez Strony, jak i w jej imieniu, w wykonaniu obowiązku ich ujawnienia na podstawie
              obowiązujących przepisów prawa.
            </li>
          </ol>
        </li>
        <li>
          W okresie obowiązywania Umowy oraz w okresie 12 (dwunastu) miesięcy po wygaśnięciu lub rozwiązaniu Umowy, każda ze Stron
          zobowiązuje się do:
          <ol className={style.second_list_abc}>
            <li>zachowania w tajemnicy wszystkich Informacji Poufnych;</li>
            <li>
              niekorzystania z uzyskanych Informacji Poufnych w jakikolwiek inny sposób i w żadnym innym celu niż na potrzeby
              realizacji Umowy, a w szczególności w celu sprzecznym z interesem drugiej Strony;
            </li>
            <li>
              niewykorzystywania uzyskanych Informacji Poufnych na szkodę drugiej Strony, w szczególności poprzez zachowanie
              stanowiące czyn nieuczciwej konkurencji zgodnie z przepisami ustawy o zwalczaniu nieuczciwej konkurencji;
            </li>
            <li>nieprzekazywania Informacji Poufnych osobom trzecim bez uzyskania uprzedniej pisemnej zgody drugiej Strony;</li>
            <li>
              zapewnienia, że w wypadku przekazania lub udostępnienia Informacji Poufnych osobom trzecim za zgodą drugiej Strony,
              osoby te zostaną zobowiązane do podpisania odpowiedniego porozumienia o poufności. Strona ponosi odpowiedzialność za
              naruszenie przez osoby, którym przekazała Informacje Poufne, obowiązku zachowania poufności.
            </li>
          </ol>
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 8 </span>
        <span>DANE OSOBOWE</span>
      </h2>
      <ol className={style.list}>
        <li>
          Mając na uwadze przedmiot Umowy oraz rodzaj Usług świadczonych przez Usługodawcę, konieczne jest powierzenia
          przetwarzania danych osobowych przez Usługobiorcę na rzecz Usługodawcy.
        </li>
        <li>
          Powierzenie Usługodawcy przetwarzania danych osobowych przez Usługobiorcę następuje w oparciu o umowę powierzenia
          stanowiącą załącznik nr 1 do OWU.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 9 </span>
        <span>OPŁATY</span>
      </h2>
      <ol className={style.list}>
        <li>
          Usługobiorca zobowiązany jest do zapłaty każdej z Opłat abonamentowych, jak również wszelkich opłat wdrożeniowych w
          terminach wynikających z Umowy. Opóźnienie w zapłacie jakiejkolwiek z kwot uprawnia Usługodawcę do naliczenia odsetek za
          opóźnienie w transakcjach handlowych.
        </li>
        <li>
          Jeśli Opłata abonamentowa obejmuje okres 1 (jednego) miesiąca, płatność pierwszej z Opłat abonamentowych następować
          będzie z płatnością Opłaty abonamentowej za drugi miesiąc.
        </li>
        <li>
          Płatność wszelkich opłat wdrożeniowych oraz Opłaty abonamentowej następować będzie w oparciu o fakturę VAT wystawianą
          przez Usługodawcę do 10 dnia każdego miesiąca, zaś w przypadku Opłat abonamentowych płatnych raz na kwartał lub raz na
          rok, do 10 dnia pierwszego miesiąca danego okresu.
        </li>
        <li>
          W zakresie w jakim jest to dozwolone przepisami prawa, Usługobiorca wyraża zgodę na wystawianie przez Usługodawcę faktur
          elektronicznych bez podpisu odbiorcy i ich doręczanie Usługobiorcy za pośrednictwem Aplikacji lub poczty elektronicznej.
          W przypadku konieczności stosowania rozwiązań informatycznych systemu KSeF, strony roboczo ustalą sposób wystawiania i
          doręczania faktur Usługobiorcy, z tym zastrzeżeniem, że ostateczną decyzję w tym zakresie podejmuje Usługodawca, zaś
          Usługobiorca będzie związany jego wytycznymi w tym zakresie.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 10 </span>
        <span>ZMIANY OWU</span>
      </h2>
      <ol className={style.list}>
        <li>Usługodawca jest uprawniony do jednostronnej zmiany warunków OWU.</li>
        <li>
          Usługobiorca zostanie poinformowany o zmianie OWU na co najmniej 14 (czternaście) dni przed dniem wejściem w życia
          zmian, za pośrednictwem poczty elektronicznej poprzez e-mail skierowany na adres Koordynatora Usługobiorcy.
        </li>
        <li>
          W przypadku braku zgody na zmianę OWU, Usługobiorca jest uprawniony do rozwiązania Umowy ze skutkiem na koniec bieżącego
          Okresu abonamentowego. W celu rozwiązania Umowy zgodnie ze zdaniem uprzednim Usługobiorca powinien skontaktować się z
          Usługodawcą drogą elektroniczną i wprost wskazać, że nie akceptuje nowych warunków OWU.
        </li>
        <li>
          W przypadku, o którym mowa w ust. 3 powyżej do czasu rozwiązania Umowy w relacjach pomiędzy Usługodawcą a Usługobiorcą
          zastosowanie mają postanowienia OWU w dotychczasowym brzmieniu.
        </li>
        <li>
          W przypadku braku wypowiedzenia Umowy przez Usługobiorcę w trybie, o którym mowa w ust. 3 powyżej w terminie 14 dni od
          dnia otrzymania informacji o zmianie OWU, nowa wersja OWU zaczyna obowiązywać Usługobiorcę automatycznie (bez
          konieczności składania jakichkolwiek dodatkowych oświadczeń przez Usługodawcę lub Usługobiorcę) wraz z datą jej
          zapowiedzianego wejścia w życie.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 11 </span>
        <span>POSTANOWIENIA KOŃCOWE</span>
      </h2>
      <ol className={style.list}>
        <li>
          Postanowienia OWU stanowią integralną część zawartych Umów i zachowują moc, o ile nie są sprzeczne z poszczególnymi
          postanowieniami Umowy.
        </li>
        <li>
          Usługobiorca ponosi pełną odpowiedzialność za własne działania i zaniechania w ramach Aplikacji, jak również za
          działania oraz zaniechania Użytkowników korzystających z Aplikacji w jego imieniu lub na jego rzecz.
        </li>
        <li>W razie rozbieżności między postanowieniami OWU a Umowy, zastosowanie mają postanowienia Umowy.</li>
        <li>
          Stronom nie przysługuje prawo przeniesienia praw i obowiązków wynikających z zawartej Umowy na podmioty trzecie, bez
          uzyskania pisemnej zgody drugiej Strony. Nie dotyczy to wymagalnych roszczeń Usługodawcy z tytułu nieopłaconych w
          terminie Opłat Abonamentowych, które mogą być przedmiotem cesji na podmiot trzeci bez konieczności uzyskiwania
          jakiejkolwiek zgody Usługobiorcy.
        </li>
        <li>
          W zakresie nieuregulowanym w OWU oraz w Umowie zastosowanie mają przepisy prawa polskiego ze szczególnym uwzględnieniem
          ustawy Kodeks cywilny oraz ustawy o prawie autorskim i prawach pokrewnych.
        </li>
        <li>
          W przypadku sporu wynikającego z OWU, Umowy lub jej wykonywania, Strony podejmą próbę polubownego rozwiązania sporu. W
          przypadku braku możliwości rozwiązania sporu w sposób polubowny, sądem właściwym będzie sąd właściwy dla dzielnicy
          Śródmieście m.st. Warszawy.
        </li>
      </ol>

      <hr className={style.divider} />

      <h3 className={style.section_header}>Załącznik 1 - Umowa powierzenia</h3>
      <ol className={style.list}>
        <li>
          Administratorem, w rozumieniu RODO, danych osobowych Użytkowników, którzy korzystają z Aplikacji w imieniu danego
          Usługobiorcy jest ten Usługobiorca. W celu umożliwienia świadczenia Usług przez Usługodawcę, konieczne jest powierzenie
          Usługodawcy przez Usługobiorcę przetwarzania danych osobowych tych Użytkowników.
        </li>
        <li>
          W związku z powyższym, z chwilą zawarcia Umowy, Usługobiorca powierza Usługodawcy do przetwarzania dane osobowe
          Użytkowników (umowa powierzenia).
        </li>
        <li>
          Usługodawca oświadcza, że dysponuje odpowiednimi środkami, w tym należytymi zabezpieczeniami umożliwiającymi
          przetwarzanie danych osobowych zgodnie z przepisami RODO i zapewniamy, iż podejmujemy wszelkie środki wymagane na mocy
          art. 32 RODO oraz spełnia wymagania określone w art. 28 RODO.
        </li>
        <li>
          Powierzenie przetwarzania jest udzielane przez Usługobiorcę na czas trwania Umowy oraz tylko i wyłącznie w celu jej
          wykonywania przez Usługodawcę. Usługobiorca powierza Usługodawcy do przetwarzania następujący rodzaj danych osobowych:
          imię, nazwisko, numer telefonu, adres e-mail, stanowisko, inne dane osobowe dobrowolnie podane przez Usługobiorcę lub
          Użytkownika jako osobę, której dane dotyczą.
        </li>
        <li>
          Usługodawca przetwarza dane osobowe wyłącznie na udokumentowane polecenie Usługobiorcy – co dotyczy też przekazywania
          danych osobowych do państwa trzeciego lub organizacji międzynarodowej – chyba że obowiązek taki nakłada na Usługodawcę
          prawo Unii lub prawo państwa członkowskiego, któremu podlegamy; w takim przypadku przed rozpoczęciem przetwarzania
          Usługodawca poinformuje Usługobiorcę o tym obowiązku prawnym, o ile prawo to nie zabrania udzielania takiej informacji z
          uwagi na ważny interes publiczny. Za takie polecenie uznaje się w szczególności zawarcie Umowy oraz każdorazowe
          logowanie się Użytkownika do Aplikacji.
        </li>
        <li>
          Usługodawca zapewnia, że osoby upoważnione do przetwarzania danych osobowych zobowiązały się do zachowania tajemnicy lub
          by podlegały odpowiedniemu ustawowemu obowiązkowi zachowania tajemnicy.
        </li>
        <li>
          Usługodawca Podejmuje wszelkie środki wymagane na mocy art. 32 RODO oraz przestrzegamy warunków korzystania z usług
          innego podmiotu przetwarzającego, o których mowa w art. 28 ust. 2 i 4 RODO.
        </li>
        <li>
          Biorąc pod uwagę charakter przetwarzania, w miarę możliwości Usługodawca pomaga Usługobiorcy - poprzez odpowiednie
          środki techniczne i organizacyjne - wywiązać się z obowiązku odpowiadania na żądania osoby, której dane dotyczą, w
          zakresie wykonywania jej praw określonych w rozdziale III RODO.
        </li>
        <li>
          Również uwzględniając charakter przetwarzania oraz dostępne dla Usługodawcy informacje, Usługodawca pomaga Usługobiorcy
          również wywiązać się z obowiązków określonych w art. 32–36 RODO.
        </li>
        <li>
          Usługodawca może powierzać przetwarzanie powierzonych przez Usługobiorcę danych osobowych innym podmiotom w celu
          realizacji funkcjonalności Aplikacji oraz w ramach wewnętrznych procesów obsługi Usługobiorców oraz Użytkowników, w tym
          w szczególności: dostawcy hostingu dla Aplikacji, dostawcy operatorowi poczty elektronicznej (e-mail), firmie
          programistycznej, dostawcy usługi do wysyłki wiadomości e-mail, księgowości, kancelarii prawnej, podmiotom zapewniającym
          rozwiązania chmurowe oraz inne rozwiązania wykorzystywane przez Usługodawcę w bieżącej działalności, która wiąże się z
          przetwarzaniem danych osobowych (ogólna zgoda administratora).
        </li>
        <li>
          Usługodawca Poinformuje Usługobiorcę o wszelkich zamierzonych zmianach dotyczących dodania lub zastąpienia innych
          podmiotów przetwarzających, na co najmniej 7 (siedem) dni roboczych przed planowanym rozpoczęciem przetwarzania przez
          inny podmiot przetwarzający, umożliwiając Usługobiorcy wyrażenie sprzeciwu na posłużenie się przez Usługodawcę innym
          podmiotem przetwarzającym. w przypadku braku takiego sprzeciwu, uważa się, że Usługobiorca wyraził zgodę na zmianę.
        </li>
        <li>
          Rozwiązanie umowy powierzenia przetwarzania danych osobowych skutkować będzie niemożliwością świadczenia przez
          Usługodawcę funkcjonalności Aplikacji i realizacji Umowy, w zakresie wymagającym przetwarzania danych, których
          administratorem jest Usługobiorca. Po zakończeniu świadczenia usług związanych z przetwarzaniem, zależnie od decyzji
          Usługobiorcy, Usługodawca usuwa lub zwraca Usługobiorcy wszelkie dane osobowe oraz usuwa wszelkie ich istniejące kopie,
          chyba że prawo Unii lub prawo państwa członkowskiego nakazują przechowywanie danych osobowych.
        </li>
        <li>
          Usługodawca udostępnia Usługobiorcy wszelkie informacje niezbędne do wykazania spełnienia obowiązków określonych w
          umowie powierzenia przetwarzania danych osobowych oraz umożliwia Usługobiorcy lub audytorowi upoważnionemu przez
          Usługobiorcę, przeprowadzanie audytów, w tym inspekcji, i przyczyniamy się do nich. Usługodawca zastrzega, że
          Usługobiorca zobowiązany jest wcześniej powiadomić Usługodawcę o planowanym audycie, z co najmniej 7-dniowym
          wyprzedzeniem, pod rygorem możliwości odmowy udziału Usługodawcy w audycie.
        </li>
        <li>
          Usługodawca niezwłocznie poinformuje Usługobiorcę, jeżeli jego zdaniem wydane Usługodawcy polecenie stanowi naruszenie
          niniejszego rozporządzenia lub innych przepisów Unii lub państwa członkowskiego o ochronie danych.
        </li>
        <li>
          Usługodawca nie ponosi odpowiedzialności za legalność pozyskiwanych przez Usługobiorcę danych osobowych ani za zgodność
          działania Usługobiorcy z RODO. Usługodawca może w tym zakresie przekazać Usługobiorcy wskazówki lub opinię, jednak nie
          jest ona zarówno dla Usługodawcy, jak i Usługobiorcy wiążąca, w szczególności nie rozszerza zakresu Umowy.
        </li>
        <li>
          Usługodawca stara się wyczerpująco odpowiadać na każde zapytanie Usługobiorcy związane z przetwarzaniem danych, w
          terminie 3 (trzech) dni roboczych od dnia doręczenia zapytania.
        </li>
        <li>
          Usługodawca zobowiązuje się też zgłaszać Usługobiorcy naruszenia związane z przetwarzaniem danych, w szczególności
          zobowiązuje się niezwłocznie, nie dłużej jednak niż w terminie 36 (trzydziestu sześciu) godzin od chwili powzięcia
          informacji, informować Usługobiorcę o wszelkich zdarzeniach mogących skutkować powstaniem odpowiedzialności Usługobiorcy
          jako administratora, na podstawie powszechnie obowiązujących przepisów związanych z ochroną danych osobowych.
        </li>
        <li>
          W przypadku przetwarzania powierzonych danych osobowych poza obszarem UE, Usługodawca przekaże Usługobiorcy, na każde
          jego żądanie, kopię dokumentów, które stanowią przesłankę legalności tego działania (np. dokument zawartych
          standardowych klauzul umownych obowiązujących w umowie z tzw. podprocesorem).
        </li>
        <li>
          Usługobiorca przyjmuje do wiadomości i akceptuje, że powierzone Usługodawcy do przetwarzania dane osobowe mogą być
          przetwarzane po rozwiązaniu Umowy w zakresie w jakim są one przechowywane w kopiach zapasowych systemu informatycznego
          składającego się na Aplikację, do momentu nadpisania ostatniej kopii zapasowej zawierającej dane osobowe, której
          administratorem jest Usługobiorca, nie dłużej niż przez okres 90 dni.
        </li>
      </ol>
    </LegalTermWrapper>
  );
};

export default Statute;
